<template>
  <div id="app">
    <GwzHeader />
    <b-container class="main">
      <router-view />
    </b-container>
  </div>
</template>

<style lang="scss">
@import "./assets/sass/sytles.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.main {
  margin-top: 60px;
}
</style>
<script>
import GwzHeader from "@/components/gwzHeader";
export default {
  components: { GwzHeader },
  created() {
    this.$store.dispatch("users/tryAutoLogin");
  }
};
</script>
